/**
 * Margins used on all the time series charts
 */
export const timeSeriesChartMargins = {
  top: 25,
  right: 18,
  left: 18,
  bottom: 5,
};
